
const classTouch  = 'touch-device';
const classHas    = 'css-has';

function isTouchDevice( ) {
  return document.documentElement.classList.contains( classTouch );
}

function supportTouch(){
  if ( 'ontouchstart' in window || navigator.maxTouchPoints > 0 ) {
    document.documentElement.classList.add( classTouch );
  }
}

function supportHas(){
  let hasSupportsHas = false;
  try {
    hasSupportsHas = CSS.supports && CSS.supports('selector(:has(*))');
  } catch (e) {
    hasSupportsHas = false;
  }
  if (hasSupportsHas) {
    document.documentElement.classList.add( classHas );
  }
}

function initModernizr( ) {
  supportTouch( );
  supportHas( );
}

export { initModernizr, isTouchDevice };
